import React from 'react'

import { autoShipItemName } from '../../../../utils/itemTools'
import { itemQuantityPrice } from '../../../../utils/priceTools'
import {
  AutoShipItemImage,
  AutoShipItemName,
  AutoShipItemNameAndQty,
  AutoShipItemPrice,
  AutoShipItemSummary,
} from './styled'
import { AutoShipItemProps } from './types'

import productPlaceholderImage from '../../../../img/product-image-placeholder.png'

const AutoShipItem: React.VFC<AutoShipItemProps> = ({ item, product }) => (
  <AutoShipItemSummary>
    <AutoShipItemImage
      alt={product.name ?? ''}
      src={product.image?.url || productPlaceholderImage}
    />
    <AutoShipItemNameAndQty>
      <AutoShipItemName>{autoShipItemName(product)}</AutoShipItemName>
      <AutoShipItemName>Quantity: {item.quantity}</AutoShipItemName>
    </AutoShipItemNameAndQty>

    <AutoShipItemPrice>
      {itemQuantityPrice({ item: product, qty: item.quantity })}
    </AutoShipItemPrice>
  </AutoShipItemSummary>
)

export default AutoShipItem
